<main>
  <div class="container">
    <div class="topheadtitle">
      <h4>Delivery Summary Report</h4>
    </div>

    <div class="table-container">
      <div class="image">
        @if (userData.length > 0) {
          <button type="button" class="btn btn-primary btn-sm" (click)="excelExport()">
            Export To Excel
          </button>
        }
      </div>

      <table class="table">
        <caption>Delivery Summary Report</caption>
        <thead>
          <tr>
            <th width="20%" scope="col" tabindex="0" [attr.role]="'button'" aria-sort="none" aria-label="Sort by Destination System" (click)="onSort($event,'destinationSystem')"
              (keydown.enter)="onSort($event,'destinationSystem')" (keydown.space)="onSort($event,'destinationSystem')">
              Destination System <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th width="20%" scope="col" tabindex="0" [attr.role]="'button'" aria-sort="none" aria-label="Sort by Queued" (click)="onSort($event,'queued')"
              (keydown.enter)="onSort($event,'queued')" (keydown.space)="onSort($event,'queued')">
              Queued <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th width="20%" scope="col" tabindex="0" [attr.role]="'button'" aria-sort="none" aria-label="Sort by Delivered" (click)="onSort($event,'delivered')"
              (keydown.enter)="onSort($event,'delivered')" (keydown.space)="onSort($event,'delivered')">
              Delivered <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th width="20%" scope="col" tabindex="0" [attr.role]="'button'" aria-sort="none" aria-label="Sort by Failed" (click)="onSort($event,'failed')"
              (keydown.enter)="onSort($event,'failed')" (keydown.space)="onSort($event,'failed')">
              Failed <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th width="20%" scope="col" tabindex="0" [attr.role]="'button'" aria-sort="none" aria-label="Sort by Rejected" (click)="onSort($event,'rejected')"
              (keydown.enter)="onSort($event,'rejected')" (keydown.space)="onSort($event,'rejected')">
              Rejected <i class="fa fa-sort" aria-hidden="true"></i>
            </th>

          </tr>
        </thead>
        <tbody>
          @for (data of userData; track data) {
            <tr>
              <td>{{ data.destinationSystem }}</td>
              <td>{{ data.queued }}</td>
              <td>{{ data.delivered }}</td>
              <td>{{ data.failed }}</td>
              <td>{{ data.rejected }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</main>